import { useHasDraft } from "../hooks/useDraft";

/**
 * DraftDot — a 6px subtle cyan dot indicating an unsaved draft.
 *
 * Minimal, on-brand, no animation. Renders nothing if no draft.
 * Pass either an exact `keyName` or a `match` (RegExp / fn) to scan multiple keys.
 */
export default function DraftDot({ keyName, match, className = "", testId }) {
  const has = useHasDraft(keyName ?? match);
  if (!has) return null;
  return (
    <span
      aria-label="Unsaved draft"
      title="Unsaved draft"
      data-testid={testId}
      className={`inline-block w-1.5 h-1.5 rounded-full bg-cyan-400/90 shrink-0 ${className}`}
    />
  );
}
